import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import image1 from '../assets/scrollimages/1.jpg'
import image2 from '../assets/scrollimages/2.jpg'
import image3 from '../assets/scrollimages/3.jpg'
import image4 from '../assets/scrollimages/5.jpg'
import image5 from '../assets/scrollimages/6.jpg'
import logo from '../assets/Logo.png'

const slides = [
  {
    id: 1,
    image:
      image1,
    title: "Startup Summit 2025",
    date: "June 25-27, 2025",
  },
  {
    id: 2,
    image:
      image2,
    title: "Innovators Meetup 2025",
    date: "July 10-12, 2025",
  },
  {
    id: 3,
    image:
      image3,
    title: "Tech Conference 2025",
    date: "August 15-17, 2025",
  },
  {
    id: 4,
    image:
      image4,
    title: "Tech Conference 2025",
    date: "August 15-17, 2025",
  },
  {
    id: 5,
    image:
      image5,
    title: "Tech Conference 2025",
    date: "August 15-17, 2025",
  },
];

export default function LongDotLanding() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <header style={styles.header}>
        <div style={styles.logoContainer}>
          <img
            src={logo}
            alt="logo"
            style={{ height: 40 }}
          />
        </div>
      </header>

      <section style={styles.sliderSection}>
        <AnimatePresence mode="wait">
          <motion.div
            key={slides[current].id}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.8 }}
            style={{
              ...styles.slide,
              backgroundImage: `url(${slides[current].image})`,
            }}
          >
            <div style={styles.slideOverlay}>
              <div style={styles.slideText}>
                <h2 style={{ margin: 0, color: "#fff", fontWeight: "bold" }}>
                  {slides[current].title}
                </h2>
                <p style={{ margin: "4px 0 0 0", color: "#ddd" }}>
                  {slides[current].date}
                </p>
              </div>
              <motion.button
                style={styles.applyButton}
                whileHover={{
                  backgroundColor: "#002c6b",
                  scale: 1.05,
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                }}
                transition={{ duration: 0.3 }}
              >
                Apply Now
              </motion.button>
            </div>
          </motion.div>
        </AnimatePresence>
      </section>

      <main style={styles.mainSection}>
        <motion.h1
          style={styles.mainHeading}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Empowering Innovators. Connecting Possibilities.
        </motion.h1>
        <motion.p
          style={styles.description}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          Your all-in-one startup growth platform: connect with investors, hire
          talent, find mentors, manage legal tasks, join incubators, and scale
          faster — everything you need to build and grow, in one place.
        </motion.p>
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <motion.button
            style={styles.seeMoreButton}
            whileHover={{
              backgroundColor: "#002c6b",
              scale: 1.05,
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
            }}
            transition={{ duration: 0.3 }}
          >
            See more
          </motion.button>
        </div>
      </main>
    </>
  );
}

const styles = {
  header: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 0",
    borderBottom: "1px solid #ddd",
    position: "sticky",
    top: 0,
    backgroundColor: "#fff",
    zIndex: 10,
    fontFamily: "Poppins, sans-serif",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  sliderSection: {
    position: "relative",
    maxWidth: 900,
    margin: "20px auto",
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
    aspectRatio: "16 / 7",
  },
  slide: {
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  slideOverlay: {
    background:
      "linear-gradient(0deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 40%, rgba(0,0,0,0) 100%)",
    padding: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  slideText: {
    color: "white",
  },
  applyButton: {
    backgroundColor: "#004a99",
    color: "white",
    border: "none",
    padding: "10px 18px",
    borderRadius: 4,
    fontWeight: "600",
    cursor: "pointer",
    fontFamily: "Poppins, sans-serif",
    transition: "background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease",
  },
  mainSection: {
    maxWidth: 800,
    margin: "30px auto 50px",
    padding: "0 20px",
    fontFamily: "Poppins, sans-serif",
  },
  mainHeading: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 8,
    maxWidth: 800,
    marginLeft: "auto",
    marginRight: "auto",
  },
  description: {
    textAlign: "center",
    color: "#555",
    lineHeight: 1.5,
    maxWidth: 750,
    marginLeft: "auto",
    marginRight: "auto",
  },
  seeMoreButton: {
    backgroundColor: "#004a99",
    border: "none",
    color: "white",
    padding: "10px 25px",
    fontWeight: "600",
    borderRadius: 6,
    cursor: "pointer",
    fontFamily: "Poppins, sans-serif",
    transition: "background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease",
  },
};
